import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: 'white' | 'transparent' | string;
}

export const PopupHeader = styled.header<IProps>`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  position: relative;
  width: 100%;
  height: 50px;
  z-index: 100;

  .inner-header {
    width: inherit;
    height: inherit;
    background-color: #fff;
    border-bottom: 1px solid #eeeeee;

    .area-left {
      position: absolute;
      top: 9px;
      left: 14px;
      z-index: 1;
    }

    .area-right {
      position: absolute;
      top: 9px;
      right: 10px;
      display: inline-flex;
      z-index: 1;

      .btn {
        margin-left: 6px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .title {
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      z-index: 0;
      font-size: 17px;
      font-weight: 600;

      span {
        max-width: ${mixin.pxToVw('210')};
        margin: 0 auto;
        ${mixin.ellipsis(1)};
      }
    }
  }

  ${props => {
    if (props.$bgType === 'transparent') {
      return css`
        height: 0;

        .inner-header {
          background-color: transparent;
          border-bottom: 0;

          svg {
            path,
            rect {
              fill: #fff;
            }
          }

          .title {
            color: #fff;
          }
        }
      `;
    }
    return null;
  }}
`;
